import React from "react"
import { BatchContactWidget } from "../components/ui/BatchContactWidget"
import { Activity, Cpu, Shield, Sparkles } from "lucide-react"

export default function Admin() {
  return (
    <div className="min-h-screen bg-slate-950 text-slate-200 pt-32 pb-20 px-6">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-16">
          <h1 className="text-4xl md:text-6xl font-bold bg-gradient-to-r from-blue-400 to-emerald-400 bg-clip-text text-transparent mb-6">
            Bridge Admin Dashboard
          </h1>
          <p className="text-xl text-slate-400 max-w-2xl mx-auto">
            Scale your AI data pipelines with professional-grade contact extraction and entity resolution.
          </p>
        </div>

        {/* Stats Section */}
        <div className="grid grid-cols-1 md:grid-cols-4 gap-6 mb-20">
          {[
            { label: 'Active Pipelines', value: '12', icon: Activity, color: 'text-blue-400' },
            { label: 'Total Extractions', value: '1.2k', icon: Cpu, color: 'text-emerald-400' },
            { label: 'Data Sources', value: '8', icon: Shield, color: 'text-purple-400' },
            { label: 'Avg Confidence', value: '94%', icon: Sparkles, color: 'text-amber-400' },
          ].map((stat, i) => (
            <div key={i} className="bg-slate-900/50 border border-slate-800 rounded-2xl p-6 backdrop-blur-sm shadow-xl">
              <div className="flex items-center justify-between mb-4">
                <stat.icon className={`w-6 h-6 ${stat.color}`} />
                <span className="text-xs font-bold text-slate-500 uppercase tracking-widest">Live</span>
              </div>
              <div className="text-3xl font-bold text-white mb-1">{stat.value}</div>
              <div className="text-sm text-slate-500 font-medium">{stat.label}</div>
            </div>
          ))}
        </div>

        <div className="mb-12">
           <h2 className="text-2xl font-bold text-white mb-8 flex items-center gap-3">
             <div className="w-2 h-8 bg-blue-500 rounded-full" />
             Batch Extraction Pipeline
           </h2>
           <BatchContactWidget />
        </div>
      </div>
    </div>
  )
}
